import { useQuery } from "@tanstack/react-query";
import { membershipApi } from "@bw/shared/api";
import type { EntitlementUsageResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * A single subscription's included-sessions usage this period (GET
 * /memberships/{id}/entitlements/{service}/usage → EntitlementUsageResponse).
 * Mirrors useVisitBalance. Only meaningful for a recurring (monthly/quarterly/
 * annual) plan; the caller enables it only for those plan types. A plan with
 * no matching entitlement configured still resolves — total=0 — the row
 * derives that into "nothing to show" rather than treating it as an error.
 */
export function useEntitlementUsage(
  subscriptionId: string | undefined,
  service: string,
  enabled = true,
) {
  return useQuery<EntitlementUsageResponse>({
    queryKey: queryKeys.memberships.entitlementUsage(
      subscriptionId ?? "",
      service,
    ),
    queryFn: () =>
      membershipApi.getEntitlementUsage(subscriptionId as string, service),
    enabled: Boolean(subscriptionId) && enabled,
    retry: false,
  });
}
